import validate from "/home/bella/vhosts/bella-nuxt/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/bella/vhosts/bella-nuxt/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "afiliado-auth": () => import("/home/bella/vhosts/bella-nuxt/middleware/afiliado-auth.ts"),
  "afiliado-convidado": () => import("/home/bella/vhosts/bella-nuxt/middleware/afiliado-convidado.ts"),
  "check-login": () => import("/home/bella/vhosts/bella-nuxt/middleware/check-login.ts"),
  "lang-redirect": () => import("/home/bella/vhosts/bella-nuxt/middleware/lang-redirect.ts"),
  "not-found-lang": () => import("/home/bella/vhosts/bella-nuxt/middleware/not-found-lang.ts")
}